<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="488">
    <div class="pr-8 pt-10 pl-11 pb-8 white">
      <v-row class="pb-7">
        <v-col cols="12">
          <p class="primary--text font-weight-bold mb-3 text-h6">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="12" v-if="subtitle">
          <p class="primary--text font-weight-bold mb-1">
            {{ subtitle }}
          </p>
        </v-col>
        <v-col cols="12">
          <p
            class="primary--text font-weight-medium mb-0"
            style="white-space: pre-line"
          >
            {{ text }}
          </p>
        </v-col>
      </v-row>
      <v-row class="pt-10">
        <v-spacer />
        <v-col cols="5" sm="3" xl="2" class="mr-5" v-if="hasCancelButton">
          <BaseButton
            v-html="textCancelButton"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal(false)"
          />
        </v-col>
        <v-col cols="5" sm="3" xl="2">
          <BaseButton
            v-html="textButton"
            :class="classButton"
            width="100%"
            @click="closeModal(true)"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
export default {
  methods: {
    closeModal(value) {
      this.$emit("close", value);
    }
  },
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    textButton: {
      type: String,
      default: "OK"
    },
    hasCancelButton: {
      type: Boolean,
      default: false
    },
    classButton: {
      type: String,
      default: "secondary"
    },
    textCancelButton: {
      type: String,
      default: "NÃO"
    },
    subtitle: {
      title: String
    }
  }
};
</script>
<style lang="sass"></style>
